export default "__VITE_ASSET__24543501__"